import template from './ios-safari-outdated.html';
import './ios-safari-outdated.scss';

export default angular
  .module('doxy.unsupportedBrowserIosSafariOutdated', [])
  .component('unsupportedBrowserIosSafariOutdated', {
    template,
    bindings: {
      onHide: '&',
    },
    controller: function () {},
  }).name;
